import { render, staticRenderFns } from "./SupplierInfo.vue?vue&type=template&id=7388a9de"
import script from "./SupplierInfo.vue?vue&type=script&lang=js"
export * from "./SupplierInfo.vue?vue&type=script&lang=js"
import style0 from "./SupplierInfo.vue?vue&type=style&index=0&id=7388a9de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports